import {SingleMustDoDataPointState} from './types'
export const ID_MAP_DEFAULT_STATE: Record<string, Array<SingleMustDoDataPointState>> = {
    salesTarget: [
        {
            id: "unit",
            label: "Unit",
            value: "Cases",
            isEditable: false
        },
        {
            id: "color",
            label: "Color",
            value: "#17C3B2",
            isEditable: false
        },
        {
            id: "heading",
            label: "Heading",
            value: "SALES TARGET",
            isEditable: true
        },
        {
            id: "subHeading",
            label: "Sub Heading",
            value: "Must Achieve Today",
            isEditable: true
        },
        {
            id: "avgValueLabel",
            label: "Avg Value Label",
            value: "Avg. Sales",
            isEditable: true
        },
        {
            id: 'last7',
            label: "Last 7 Days Label",
            value: "L7 Days",
            isEditable: false
        },
        {
            id: 'tagHeading',
            label: "Tag Heading",
            value: "Total",
            isEditable: false,
        },
        {
            id: 'tagSubHeading',
            label: "Tag Sub Heading",
            value: "Outlets",
            isEditable: false,
        },
        {
            id: 'supervisorHeading',
            label: "Supervior Tab Heading",
            value: "SALES TARGET",
            isEditable: false,
        }
        
    ],
    mustOrderOutlets: [
        {
            id: "heading",
            label: "Heading",
            value: "MUST ORDER OUTLETS",
            isEditable: true
        },
        {
            id: "subHeading",
            value: "To Drive Effective Call",
            label: "Sub Heading",
            isEditable: true
        },
        {
            id: "avgValueLabel",
            label: "Avg Value Label",
            value: "Avg. Billed Outlets",
            isEditable: true
        },
        {
            id: "unit",
            label: "Unit",
            value: "Stores",
            isEditable: true
        },
        {
            id: "color",
            label: "Color",
            value: "#e6654b",
            isEditable: false
        },
        {
            id: 'last7',
            label: "Last 7 Days Label",
            value: "L7 Days",
            isEditable: false
        },
        {
            id: 'supervisorHeading',
            label: "Supervior Tab Heading",
            value: "MUST ORDER",
            isEditable: false,
        }

    ],
    focus: [
        {
            id: "heading",
            label: "Heading",
            value: "MUST SELL SKUs",
            isEditable: true
        },
        {
            id: "subHeading",
            value: "MSL To Be Sold",
            label: "Sub Heading",
            isEditable: true
        },
        {
            id: "avgValueLabel",
            label: "Avg Value Label",
            value: "Must Sell Stores",
            isEditable: true
        },
        {
            id: "unit",
            label: "Unit",
            value: "Stores",
            isEditable: true
        },
        {
            id: "color",
            label: "Color",
            value: "#227C9D",
            isEditable: false
        },
        {
            id: 'last7',
            label: "Last 7 Days Label",
            value: "L7 Days",
            isEditable: false
        },
        {
            id: 'supervisorHeading',
            label: "Supervior Tab Heading",
            value: "FOCUS PRODUCTS",
            isEditable: false,
        }
    ],
}


export const ID_MAP_DEFAULT_INFO: Record<string, { label: string, description: string }> = {
    salesTarget: {
        label: "Sales Target",
        description: "Add labels to customise you app:"
    },
    mustOrderOutlets: {
        label: "Must Order Outlet",
        description: "Add labels to customise you app:"
    },
    mustSellSKUs: {
        label: "Must Sell SKU",
        description: "Add labels to customise you app:"
    },
    focus: {
        label: "Must Sell SKU",
        description: "Add labels to customise you app:"
    }
}

export const MUST_DO_ACTION_ORDER_ID: Record<string, number> = {
    salesTarget: 0,
    mustOrderOutlets: 0,
    mustSellSKUs: 0,
    focus:0
}

export const ID_TAB_ICON_PATH: Record<string, string> = {
    salesTarget:"assets/svg/total_outlets.svg",
    mustOrderOutlets:"assets/svg/must_order_outlets.svg",
    mustSellSKUs:"assets/svg/focus_products.svg",
    focus:"assets/svg/focus_products.svg",
}

export const ID_SUPERVISOR_TAB_ICON_PATH: Record<string, string> = {
    salesTarget:"assets/svg/jnj_sales_icon.svg",
    mustOrderOutlets:"assets/svg/must_order.svg",
    mustSellSKUs:"assets/svg/home.svg",
    focus:"assets/svg/home.svg",
}

export function hexToRgba(hex: string, opacity: (string | number) = 1) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}